// The rubric textarea is filled on open by the first non-blank of, in order:
// the last run's rubric, the award default, then the recommended template.
// "Blank" is whitespace-only (matches the dialog's original seed test).
export const pickSeedRubric = (
  lastRunRubric: string | undefined,
  awardDefault: string | undefined,
  template: string,
): string => {
  if (lastRunRubric && lastRunRubric.trim() !== '') return lastRunRubric;
  if (awardDefault && awardDefault.trim() !== '') return awardDefault;
  return template;
};
